import { Button, EmptyState, Pagination, Paper } from 'components'
import { Filter, TMATTFilter } from 'components/Filter'
import { RefresherFilter } from 'components/Filter/RefresherFilter'
import {
  SortBySelect,
  studentListColumns,
  Table,
  TableContentLoader,
} from 'components/Table'
import { teacherTrainingListColumns } from 'components/Table/columns'
import { UseListOutput } from 'hooks/userHooks/useList'
import { ListTypes } from 'pages/Dashboard'
import { useHistory } from 'react-router-dom'
import { Box, Flex } from 'theme-ui'
import { StatusType } from 'types'

export type UserListProps = {
  isPageVisited?: boolean
  activeList?: ListTypes | string
} & UseListOutput

export const UserList = ({
  isPageVisited = true,
  data,
  params,
  state,
  activeList,
  list,
}: UserListProps) => {
  const history = useHistory()
  function handleFilter(
    filters: StatusType[],
    progress: StatusType[],
    type?: StatusType[]
  ) {
    list({
      filters: {
        filters,
        progress,
        type:
          activeList === 'tmatt' || activeList === 'refresher'
            ? undefined
            : type,
      },
      page: 1,
      type: activeList ? activeList : 'student',
    })
  }

  function handleSortByChange(value: string) {
    list({ sort: value, type: activeList ? activeList : 'student' })
  }

  function handlePageChange(e: React.ChangeEvent<unknown>, page: number) {
    list({ page, type: activeList ? activeList : 'student' })
  }

  function openUserForm(id: string) {
    history.push({
      pathname: `/user/${id}`,
    })
  }
  const emptyStateIcon = `${activeList || 'student'}-list`

  function handleCreateUserClick() {
    history.push({
      pathname: `/${activeList || 'student'}/new`,
    })
  }

  return (
    <>
      <Box sx={{ mt: 4, mb: 100, width: '100%' }}>
        <Flex
          sx={{ py: 4, px: 4, minHeight: 52, justifyContent: 'space-between' }}>
          <SortBySelect
            activeList={activeList}
            disabled={false}
            onSelectChange={handleSortByChange}
          />
          {activeList === 'tmatt' ? (
            <TMATTFilter disabled={false} handleSubmit={handleFilter} />
          ) : activeList === 'refresher' ? (
            <RefresherFilter disabled={false} handleSubmit={handleFilter} />
          ) : (
            <Filter
              disabled={data.total === 0 && !params.filters}
              handleSubmit={handleFilter}
            />
          )}
        </Flex>
        <Paper
          sx={{ display: 'flex', flexDirection: 'column', minHeight: 544 }}
          withShadow>
          {state.matches('syncing') && <TableContentLoader />}
          {state.matches('success') && (
            <Table
              sorting={params.sort}
              data={data.users}
              columns={
                activeList === 'tmatt' || activeList === 'refresher'
                  ? teacherTrainingListColumns
                  : studentListColumns
              }
              onRowClick={openUserForm}
              activeList={activeList || 'student'}
            />
          )}
          {state.matches('success') && data.total === 0 && params.filters && (
            <Flex
              sx={{
                alignItems: 'center',
                justifyContent: 'center',
                minHeight: 500,
              }}>
              <EmptyState
                icon={emptyStateIcon}
                heading="No results found"
                text="Change the filter settings in order to find what you are looking for."
                withPaper={false}
              />
            </Flex>
          )}
          {state.matches('success') &&
            data.total === 0 &&
            !data.users?.length &&
            !params.filters && (
              <Flex
                sx={{
                  alignItems: 'center',
                  justifyContent: 'center',
                  minHeight: 500,
                }}>
                {!isPageVisited ? (
                  <EmptyState
                    icon={emptyStateIcon}
                    heading={`Your list of users is empty`}
                    text={
                      activeList === 'tmatt'
                        ? 'No teacher has started the training yet. Create or enroll one'
                        : 'You don’t have any student yet. Create your first student now.'
                    }
                    button={
                      <Button onClick={handleCreateUserClick}>
                        Create new{' '}
                        {activeList === 'tmatt' ? 'teacher' : 'student'}
                      </Button>
                    }
                    withPaper={false}
                  />
                ) : (
                  <EmptyState
                    icon={emptyStateIcon}
                    heading={`Your list of users is empty`}
                    text="There are no users for you to view."
                    withPaper={false}
                  />
                )}
              </Flex>
            )}
          {state.matches('failed') && (
            <Box sx={{ mt: 4, mb: 100, width: '100%' }}>
              <EmptyState
                heading="Oops!"
                text="Something Went Wrong! Try Refreshing the page."
              />
            </Box>
          )}
          <Box sx={{ mt: 'auto', py: 5, height: 35 }}>
            {state.matches('success') && data.total > 0 && (
              <Pagination
                total={data.total}
                count={params.size}
                page={params.page}
                onPageChange={handlePageChange}
              />
            )}
          </Box>
        </Paper>
      </Box>
    </>
  )
}
